import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { Spinner, Clock, ArrowClockwise } from "@phosphor-icons/react";
import { PaymentSuccess } from "./PaymentSuccess";

const MAX_TRIES = 25;

// Tela exibida quando o comprador volta do checkout de cartão (?tx=...&session_id=...)
export const CardReturn = ({ txId, pollStatus, onDismiss }) => {
  const [state, setState] = useState("checking");
  const [tries, setTries] = useState(0);
  const [done, setDone] = useState(null);

  useEffect(() => {
    if (state !== "checking") return undefined;
    let alive = true;
    const t = setTimeout(async () => {
      try {
        const r = await pollStatus(txId);
        if (!alive) return;
        if (r.status === "approved") { setDone(r); setState("approved"); return; }
      } catch (e) { console.warn("card poll", e?.message); }
      if (!alive) return;
      if (tries + 1 >= MAX_TRIES) setState("timeout");
      else setTries((n) => n + 1);
    }, tries === 0 ? 300 : 2500);
    return () => { alive = false; clearTimeout(t); };
  }, [state, tries, txId, pollStatus]);

  return createPortal(
    <div className="fixed inset-0 z-[95] flex items-center justify-center p-4 bg-black/80 backdrop-blur-md" data-testid="card-return-overlay">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-[460px] rounded-[28px] bg-[#121824] border border-white/10 p-6 sm:p-8 text-[#F8FAFC]">
        {state === "checking" && (
          <div className="text-center py-6" data-testid="card-return-checking">
            <div className="relative mx-auto w-20 h-20 flex items-center justify-center">
              <span className="absolute inset-0 rounded-full border-2 border-[#FFB30F]/20" />
              <Spinner size={44} className="animate-spin text-[#FFB30F]" />
            </div>
            <div className="font-display font-black text-2xl mt-5">Confirmando seu pagamento</div>
            <p className="text-sm text-slate-400 mt-2">Estamos validando seu cartão. Isso leva só alguns segundos — não feche esta página.</p>
          </div>
        )}
        {state === "approved" && done && <PaymentSuccess redirectUrl={done.redirect_url} buyerName={done.buyer_name} />}
        {state === "timeout" && (
          <div className="text-center py-4" data-testid="card-return-timeout">
            <Clock size={48} className="mx-auto text-[#FFB30F]" weight="duotone" />
            <div className="font-display font-black text-xl mt-4">Pagamento em processamento</div>
            <p className="text-sm text-slate-400 mt-2">Ainda não recebemos a confirmação. Se o valor foi debitado, a liberação acontece automaticamente em instantes.</p>
            <button type="button" onClick={() => { setTries(0); setState("checking"); }} className="vb-cta mt-6" data-testid="card-return-retry-btn">
              <ArrowClockwise size={18} weight="bold" /> Verificar novamente
            </button>
            <button type="button" onClick={onDismiss} className="mt-3 text-xs text-slate-400 hover:text-white transition-colors" data-testid="card-return-dismiss-btn">
              Voltar para a página
            </button>
          </div>
        )}
      </motion.div>
    </div>,
    document.body,
  );
};
